import { render } from "./AssociationText.vue?vue&type=template&id=070d1f82"
import script from "./AssociationText.vue?vue&type=script&lang=js"
export * from "./AssociationText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__